import React from 'react';
import '../../styles/common/AdminPageContainer.css';

const AdminPageContainer = ({ 
  children, 
  className = '' 
}) => {
  return (
    <div className={`admin-page-container ${className}`}>
      {children}
    </div>
  );
};

export default AdminPageContainer;
